<template>
  <div>
    <navigation />
    <topnav />
    <div class="task-container">
      <div class="task-content">
        <div class="task-info">
          <div class="taskinfo-column">
            <span>任务ID：{{ taskId }}</span>
            <span>标注方式：{{ task.taskTypeName }}</span>
          </div>
          <div class="taskinfo-column" style="width: 280px;">
            <span>任务名：{{ task.taskName }}</span>
            <div style="display: block;">
              <span style="display: inline-block; margin: 0px;">类别：</span>
              <div id="class-name">
                <span class="class-info" style="margin: 0px;">{{ classInfoText }}</span>
                <div class="class-info">
                  <section v-for="classes of task.classifications" :key="'category' + classes.categoryId">
                    <span style="margin: 0px 6px 7px;">{{ classes.categoryName }}</span>
                    <p v-for="(cSlice, index) of classSlice(classes.classes)" :key="`cSlice${index}`">
                      <span v-for="c of cSlice" :key="`class${c.classId}`">{{ c.className }}</span>
                    </p>
                  </section>
                </div>
              </div>
            </div>
          </div>
          <div class="taskinfo-column" style="margin-right: 180px;">
            <span style="margin-bottom: 12px;">任务状态：{{ taskStatusMap[task.taskStatus] }}</span>
            <span style="display: inline-block;padding: 0px;">图片类型：</span>
            <select v-model="imageStatus">
              <option value="">所有图片</option>
              <option value="2">标注中</option>
              <option value="3">一审中</option>
              <option value="4">二审中</option>
              <option value="5">已完成</option>
              <option value="-1">无框图</option>
            </select>
          </div>
        </div>
        <div class="image-info">
          <span>所有图片：{{ task.imageCount }}</span>
          <span>标注中：{{ task.unAnnotatedCount }}</span>
          <span>一审中：{{ task.annotatedCount }}</span>
          <span>一审完成：{{ task.approvedOneCount }}</span>
          <span>模型提交二审: {{ task.modelApproveTwoCount }}</span>
          <span>已完成：{{ task.approvedTwoCount }}</span>
        </div>
        <div class="task-btn">
          <button class="solid-btn" @click="editTask()">编辑任务</button>
          <button class="solid-btn" @click="dialogVisible = true" v-if="canStart">
            {{ task.taskStatus === 0 ? '开始任务' : '更新任务' }}
          </button>
          <button class="solid-btn" @click="continueTaskModalVisible = true" v-if="task.taskStatus === 4">
            继续任务
          </button>
        </div>
      </div>
      <imagelist
        :image-list="imageList"
        :task-id="taskId"
        :page-index="pageIndex"
        :page-size="pageSize"
        :image-status="imageStatus"
        @getImageList="getImageList"
      />
      <pagination
        :page-size="pageSize"
        :page-index="pageIndex"
        :item-total="itemTotal"
        @changeindex="changePageIndex"
        @changesize="changePageSize"
      />
      <!--确认任务开始状态-->
      <el-dialog title="请选择任务开始状态" :visible.sync="dialogVisible">
        <el-select v-model="taskStartStatus" placeholder="请选择">
          <el-option v-for="item in taskStatusOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="startTask">确 定</el-button>
        </div>
      </el-dialog>
      <!--提交需要二审的图片-->
      <el-dialog title="二审图片ID" :visible.sync="continueTaskModalVisible">
        <el-input type="textarea" placeholder="图片ID格式: 1,2,3,4" v-model="continueAuditTaskIds"></el-input>
        <div slot="footer" class="dialog-footer">
          <el-button @click="continueTaskModalVisible = false">取 消</el-button>
          <el-button type="primary" @click="setImageToApproverTwo">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import imagelist from '@/components/imagelist';
import pagination from '@/components/pagination';
import navigation from '@/components/navigation';
import topnav from '@/components/topnav';
import * as api from '@/api/api.js';
import { taskStatusMap } from '@/config';

export default {
  name: 'taskdetail',
  data() {
    return {
      pageSize: 20,
      pageIndex: 0,
      itemTotal: 0,
      task: {},
      taskId: 0,
      classifications: [],
      taskStatusMap: [],
      imageList: [],
      imageStatus: '',
      dialogVisible: false,
      taskStartStatus: 2, // 管理员开始任务时自定义起始状态，实际使用中存在任务紧急直接一审、二审情况
      taskStatusOptions: [
        {
          value: 2,
          label: '标注',
        },
        {
          value: 3,
          label: '一审',
        },
        {
          value: 4,
          label: '二审',
        },
      ],
      continueTaskModalVisible: false,
      continueAuditTaskIds: '',
    };
  },
  components: {
    imagelist,
    pagination,
    navigation,
    topnav,
  },
  watch: {
    imageStatus: function() {
      this.getImageList();
    },
  },
  computed: {
    classInfoText: function() {
      if (this.task && this.task.classifications && this.task.classifications[0]) {
        return this.task.classifications[0].classes.map(item => item.className).join(',');
      } else return '';
    },
    canStart: function() {
      if (this.task.unAnnotatedCount > 0 && [0, 3, 4].includes(this.task.taskStatus)) return true;
      return false;
    },
  },
  mounted: function() {
    if (this.$route.query && this.$route.query.status) this.imageStatus = this.$route.query.status;
    this.taskStatusMap = taskStatusMap;
    this.taskId = this.$route.params.id;
    if (this.$route.query.f === 'd' && this.$route.query.page) this.pageIndex = parseInt(this.$route.query.page);
    this.getTaskInfo();
    this.getImageList();
  },
  methods: {
    classSlice(classes) {
      let res = [];
      let row = Math.ceil(classes.length / 4);
      for (let i = 0; i < Math.ceil(classes.length / row); i++) {
        res.push(classes.slice(i * row, i * row + row));
      }
      return res;
    },
    getImageList() {
      api
        .getImageList({ page: this.pageIndex, pagesize: this.pageSize, status: this.imageStatus }, this.taskId)
        .then(res => {
          this.imageList = res.data.images;
          this.itemTotal = res.data.imageCount;
        })
        .catch(() => {});
    },
    getTaskInfo() {
      api
        .getTaskInfo({ taskId: this.taskId })
        .then(res => {
          this.task = res.data.task;
          this.classifications = res.data.task.classifications;
        })
        .catch(() => {});
    },
    startTask() {
      this.dialogVisible = false;
      api
        .startTask({ taskId: this.taskId, status: this.taskStartStatus })
        .then(() => {
          if (this.task.taskStatus === 0) {
            this.$notify({
              group: 'foo',
              text: '任务已开始',
              type: 'custom-blue',
              duration: 1500,
            });
          } else {
            this.$notify({
              group: 'foo',
              text: '任务图片已更新',
              type: 'custom-yellow',
              duration: 1500,
            });
          }

          this.getTaskInfo();
        })
        .catch(() => {});
    },
    stopTask() {
      if (!window.confirm('终止后的任务将从任务列表中删除，请确认。')) return;
      api
        .stopTask({ taskId: this.taskId })
        .then(() => {
          this.$notify({
            group: 'foo',
            text: '任务已终止',
            type: 'custom-red',
            duration: 1500,
          });
          this.$router.push({ path: '/tasklist' });
        })
        .catch(() => {});
    },
    editTask() {
      this.$router.push({ path: '/edittask/' + this.taskId });
    },
    setImageToApproverTwo() {
      const imageIds = this.continueAuditTaskIds.replace(/[\r\n]/g, '');
      if (imageIds.match(/[^\d,]+/g)) {
        this.$message.warning('图片ID列表存在非逗号和数字符号');
        return;
      }
      const imageIdList = imageIds.split(',').reduce((pre, cur) => {
        if (cur) {
          pre.push(parseInt(cur));
        }
        return pre;
      }, []);
      api
        .setImageToApproverTwo(this.taskId, { imageIdList })
        .then(() => {
          this.continueTaskModalVisible = false;
          this.$message.success('二审图片提交成功');
        })
        .catch(() => {
          this.continueTaskModalVisible = false;
        });
    },
    changePageIndex: function(pi) {
      this.pageIndex = pi;
      this.getImageList();
    },
    changePageSize: function(ps) {
      this.pageSize = parseInt(ps);
      this.pageIndex = 0;
      this.getImageList();
    },
  },
};
</script>
<style scoped>
section {
  display: inline-block;
  width: max-content;
  vertical-align: top;
  padding: 0px 10px;
  color: #595959;
}
section span {
  display: block;
  margin: 5px;
  padding: 5px;
}
span {
  display: inline-block;
}
button {
  padding: 10px 14px;
  margin: 0px;
  margin-left: 12px;
}
select {
  border: none;
  appearance: none;
  font-size: 16px;
  background: #ffffff;
  color: #5d89c0;
  cursor: pointer;
}
p {
  display: inline-block;
  margin: 0px 6px;
  vertical-align: top;
}
.task-content {
  margin-top: 12px;
  margin-bottom: 30px;
  position: relative;
}
.task-info {
  display: inline-block;
}
.taskinfo-column {
  display: inline-block;
  width: 200px;
  line-height: 100%;
  margin-top: 12px;
  vertical-align: top;
}
.taskinfo-column span {
  display: block;
  line-height: 100%;
  padding-right: 10px;
}
.taskinfo-column span:first-child {
  margin-bottom: 16px;
}
.task-btn {
  display: inline-block;
  position: absolute;
  bottom: 4px;
  right: 0px;
}
#class-name {
  display: inline-block;
  vertical-align: middle;
  margin: 0px;
}
span.class-info {
  display: inline-block;
  position: relative;
  text-decoration: underline;
  color: #5d89c0;
  padding: 0px;
  text-overflow: ellipsis;
  width: 128px;
  overflow: hidden;
  white-space: nowrap;
  margin: 0px;
}
span.class-info:hover + div.class-info {
  visibility: visible;
}
div.class-info {
  background-color: #ffffff;
  padding: 16px 2px;
  width: max-content;
  position: absolute;
  visibility: hidden;
  z-index: 999;
  border: 1px solid #eeeeee;
  color: #5d89c0;
  box-shadow: 0px 2px 4px 0px rgba(221, 221, 221, 1);
  border-radius: 0px 0px 5px 5px;
}
div.class-info section span {
  padding: 0px 0px 5px 0px;
  margin: 0px;
}
div.class-info section span:first-child {
  padding: 0px 0px 5px 0px;
  margin: 0px;
}
.image-info {
  margin-top: 12px;
}
.image-info > span {
  display: inline-block;
  margin-right: 22px;
}
.task-container {
  padding: 84px 50px 0px 301px;
}
/deep/.el-textarea textarea {
  height: 150px !important;
}
</style>
